module.exports = __webpack_public_path__ + "static/media/hubs2.7afb96f2.png";